/**
 * @chat/protocol
 *
 * Wire-format shared between the Cloudflare Worker backend and the PWA client.
 * Zero runtime dependencies — safe to import from either side.
 */

export const PROTOCOL_VERSION = 2 as const;

export * from './base64.js';
export * from './errors.js';
export * from './ids.js';
export * from './envelope.js';
export * from './auth.js';
export * from './directory.js';
export * from './invitation.js';
export * from './push.js';
